import { getHeightDisplayNone } from "./size-utils";

export function expandContainer(container: HTMLElement, elementHeight = 0, useDisplayNone = false): Promise<string> {
  return new Promise((resolve): void => {
    function onExpandTransitionEnd(e: TransitionEvent): void {
      const container = e.target as HTMLElement;
      if (container.classList.contains("expand")) {
        container.removeEventListener("transitionend", onExpandTransitionEnd, false);
        container.classList.remove("expand");

        const date = new Date();
        resolve(`${date.getMinutes()};${date.getMilliseconds()}`);
      }
    }

    container.classList.add("expand");

    const elementHeight2 = getHeightDisplayNone(container);
    if (elementHeight2 !== 0 && (elementHeight === 0 || elementHeight > elementHeight2)) {
      elementHeight = elementHeight2;
    }

    container.style.height = "0px";

    if (useDisplayNone) {
      container.style.display = "block";
    } else {
      container.classList.remove("faq-hide");
    }

    container.style.opacity = "1";

    setTimeout((): void => {
      container.addEventListener("transitionend", onExpandTransitionEnd, false);
      container.style.height = `${elementHeight}px`;
    }, 20);
  });
}

export function collapseContainer(
  container: HTMLElement,
  hideClass = "faq-hide",
  useDisplayNone = false,
): Promise<string> {
  return new Promise((resolve): void => {
    const dt = new Date();
    const collapsReference = `collaps_${dt.getSeconds()}${dt.getMilliseconds()}`;
    function onCollapsTransitionEnd(e: TransitionEvent): void {
      const container = e.target as HTMLElement;
      if (container.classList.contains(collapsReference)) {
        if (useDisplayNone) {
          container.style.display = "none";
        } else {
          container.classList.add(hideClass);
        }

        container.style.height = "";
        container.style.opacity = "0";
        resetVerticalMAndP(container);
        container.removeEventListener("transitionend", onCollapsTransitionEnd, false);
        container.classList.remove(collapsReference);
        resolve("");
      }
    }

    container.classList.add(collapsReference);
    const height = container.scrollHeight;
    container.style.height = `${height}px`;
    setTimeout((): void => {
      container.addEventListener("transitionend", onCollapsTransitionEnd, false);
      container.style.height = "0";
    }, 2);
  });
}

export function fadeInOutContainer(container: HTMLElement, fadeOut: boolean): Promise<string> {
  return new Promise((resolve): void => {
    function onFadeTransitionEnd(e: TransitionEvent): void {
      const container = e.target as HTMLElement;
      if (container.classList.contains("fade")) {
        container.removeEventListener("transitionend", onFadeTransitionEnd, false);
        container.classList.remove("fade");

        resolve("");
      }
    }

    container.classList.add("fade");

    if (fadeOut === true) {
      container.addEventListener("transitionend", onFadeTransitionEnd, false);
      container.style.opacity = "0";
    } else {
      container.classList.remove("faq-hide");
      setTimeout((): void => {
        container.addEventListener("transitionend", onFadeTransitionEnd, false);
        container.style.opacity = "1";
      }, 100);
    }
  });
}

function resetVerticalMAndP(item: HTMLElement): void {
  item.style.marginTop = "";
  item.style.marginBottom = "";
  item.style.paddingTop = "";
  item.style.paddingBottom = "";
}
